module.exports = __webpack_public_path__ + "static/lato-v14-latin-300-fc1bb181d71353cda49b40aa19384bbd.eot";